import React from 'react';

const index = () => {
  return (
    <div className="no-gutters pl-5 text-white flight-header">
      <div className="col-sm-8">
        <p className="flight-title">Contact Person Detail</p>
      </div>
      <div className="col-sm-4 col-12 p-4 p-sm-5">
        <div className="d-flex">
          <p className="flight-detail">Flight Detail</p>
          <p className="ml-auto pt-2 mr-5">View Details</p>
        </div>
      </div>
    </div>
  );
};

export default index;
